import React, { useMemo } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Switch } from "@progress/kendo-react-inputs";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { icon } from "../../../../config";
import { formatDate } from "../../../../helper/common";
import { useEmailRules } from "./EmailRulesContext";
import { labels } from "./ruleEngine.constants";
import "./rules.scss";

/**
 * Component that displays a single email rule card
 * PC : RulesList
 * @author Sarthak Arora
 */
const RuleCard = ({ rule, index, onEdit, onToggle }) => {
  const { actions } = useEmailRules();

  /**
   * converts the comma-separated action IDs to action objects
   * @param {string} actionIds - The comma-separated action IDs
   * @author Sarthak Arora
   */

  const ruleActions = useMemo(() => {
    if (!rule?.actions || !actions?.length) return [];
    return rule.actions
      .split(",")
      .map((id) => {
        const action = actions.find((a) => a.Id === parseInt(id));
        return action;
      })
      .filter(Boolean);
  }, [rule?.actions, actions]);

  return (
    <div className='rule-card'>
      <div className='rule-card-main'>
        <div className='rule-title d-flex justify-content-between align-items-center'>
          <h3 className="word-break-all">{rule.name}</h3>
          <Tooltip parentTitle='true' position='bottom'>
            <div className=' d-flex justify-content-end rule-controls align-items-center'>
              <div id={`edit-rule-${rule.id}`} className='edit-button mr-1' onClick={() => onEdit(rule)}>
                {icon.EDIT_RULE}
              </div>

              <div title={rule.isDisabled ? labels.ENABLE_RULE : labels.DISABLE_RULE}>
                {" "}
                <Switch id={`toggle-rule-${rule.id}`} checked={!rule.isDisabled} onChange={() => onToggle(rule)} className='rule-toggle' />
              </div>
            </div>
          </Tooltip>
        </div>
        <Tooltip parentTitle={true} position='bottom'>
          <div className='rule-meta'>
            <span className='created-by text-truncate creator-icon' title={rule?.createdBy}>
              {icon.USER_ICON} {rule?.createdBy || labels.CREATED_BY_UNKNOWN}
            </span>

            <span className='created-date text-nowrap'>{formatDate(rule?.createdOn)}</span>
            <div className='rule-actions'>
              {ruleActions.map((action, idx) => (
                <Tooltip parentTitle position='bottom' key={idx}>
                  <span title={action.Action} key={`action-${rule.id}-${idx}`} className='action-icon cursor-pointer'>
                    {icon[action.Icon]}
                  </span>
                </Tooltip>
              ))}
            </div>
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default RuleCard;
